export const name = 'nativeMobileWixCodeSdk' as const
export const navigationNamespace = 'navigate-mobile' as const
export const mobileNamespace = 'mobile' as const
export const storageNamespace = 'storage-mobile' as const
